import React from "react";
import ChartPanel from "../components/chart/ChartPanel";
import UtilityDock from "../components/dock/UtilityDock";
import { useMarket } from "../context/MarketContext";
import { useWorkspace } from "../context/WorkspaceContext";

// /chart?symbol=&interval= — chart-first workspace: the chart IS the page; utilities live in the right dock.
export default function ChartPage() {
  const { quotes } = useMarket();
  const ws = useWorkspace();
  return (
    <div data-testid="page-chart" className="flex flex-col md:flex-row h-full min-h-0 w-full">
      <div className="flex-1 min-w-0 min-h-0 md:h-full"><ChartPanel symbol={ws.symbol} tf={ws.tf} onTfChange={ws.setTf} quote={quotes[ws.symbol]} /></div>
      <UtilityDock />
    </div>
  );
}
